import { IMaintenanceActions, MaintenanceContext } from './actions.types';
import { IMaintenanceData } from '@/models';
import { IFetchMaintenancesParams } from '@/services';

export const actions: IMaintenanceActions = {
  fetchMaintenances(
    context: MaintenanceContext,
    params: IFetchMaintenancesParams
  ): Promise<void> {
    const promise = this.$services.maintenance.fetchMaintenances(params);
    context.commit('SET_LAST_PROMISE', promise);
    return promise.then((maintenances: IMaintenanceData[]) => {
      if (promise == context.state.lastPromise) {
        context.commit('SET_MAINTENANCES', maintenances);
        context.commit('SET_LAST_PROMISE', null);
      }
    });
  },

  fetchMaintenance(
    context: MaintenanceContext,
    payload: number
  ): Promise<void> {
    return this.$services.maintenance
      .fetchMaintenance(payload)
      .then((maintenance: IMaintenanceData) => {
        const index = context.state.maintenances.findIndex(
          (v: IMaintenanceData) => v.id === maintenance.id
        );
        if (index === -1) {
          context.commit('ADD_MAINTENANCE', maintenance);
        } else {
          context.commit('UPDATE_MAINTENANCE', maintenance);
        }
      });
  },

  createMaintenance(
    context: MaintenanceContext,
    payload: IMaintenanceData
  ): Promise<void> {
    return this.$services.maintenance
      .createMaintenance(payload)
      .then((maintenance: IMaintenanceData) =>
        context.commit('ADD_MAINTENANCE', maintenance)
      );
  },

  updateMaintenance(
    context: MaintenanceContext,
    payload: IMaintenanceData
  ): Promise<void> {
    return this.$services.maintenance
      .updateMaintenance(payload)
      .then((maintenance: IMaintenanceData) => {
        const index = context.state.maintenances.findIndex(
          (v: IMaintenanceData) => v.id === maintenance.id
        );
        if (index === -1) {
          context.commit('ADD_MAINTENANCE', maintenance);
        } else {
          context.commit('UPDATE_MAINTENANCE', maintenance);
        }
      });
  },

  deleteMaintenance(
    context: MaintenanceContext,
    payload: number
  ): Promise<void> {
    return this.$services.maintenance.deleteMaintenance(payload).then(() => {
      context.commit('REMOVE_MAINTENANCE', payload);
    });
  }
};
